import { axiosLineNotiClient } from '../plugins/axios'
const TokenTest =
  'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IkhTMjNiN0RvN1RjYVUxUm9MSHdwSXEyNFZZZyIsImtpZCI6IkhTMjNiN0RvN1RjYVUxUm9MSHdwSXEyNFZZZyJ9.eyJhdWQiOiJhcGk6Ly9jbXUiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC9jZjgxZjFkZi1kZTU5LTRjMjktOTFkYS1hMmRmZDA0YWE3NTEvIiwiaWF0IjoxNzU5OTkxODM3LCJuYmYiOjE3NTk5OTE4MzcsImV4cCI6MTc1OTk5NzUxNCwiYWNyIjoiMSIsImFpbyI6IkFaUUFhLzhhQUFBQVBVY1JRaGgxRTZyTVF2eWJBU2xWQnFmWi9uOFYwREc0RzF0Zll1NXVXRTJRVXJiZ21Jd1kzWXNRWjJ5UG5TT2FLbDZKRGY3a0NxMVAwNDdNR1R2b3NadUtBYXphSHJ2bE1ydTBGU1k4N1BuOFNIU1V3NUJ2c2VkZCtiazFoSHdBQURnSjQwYmlLWFBwRGV4NGVCL1BaZHZIZm5tZUZmYXZIanN6LzRRVklSaXhuazFOSzJZZ2VMd3hqMytqL0lwTSIsImFtciI6WyJwd2QiLCJtZmEiXSwiYXBwaWQiOiIwYWRhZGNjMi0zNGQxLTQzY2QtODBiZi04YjJhZWZjOGVkNmYiLCJhcHBpZGFjciI6IjEiLCJmYW1pbHlfbmFtZSI6IllBTUFOTyIsImdpdmVuX25hbWUiOiJLSVRJU0FLIiwiaXBhZGRyIjoiMjAyLjI4LjI1MS4zNiIsIm5hbWUiOiJLSVRJU0FLIFlBTUFOTyIsIm9pZCI6IjYwMGNiNTljLWZmNjEtNDAxOC1hODkyLTg2NWMyNWUwMjg0MiIsIm9ucHJlbV9zaWQiOiJTLTEtNS0yMS0zMTc2NTU1MzQ2LTIxOTY1MjgwOTgtMzEyMjM3NTIwLTEwMjczNyIsInJoIjoiMS5BWEVBM19HQnoxbmVLVXlSMnFMZjBFcW5VYjh0VmxsZV9rWkh2Qzc2eE10emdUQXZBYlJ4QUEuIiwic2NwIjoiTWlzLkFjY291bnQuUmVhZC5NZS5CYXNpY2luZm8gTWlzLkhyLlJlYWQuTWUuQmFzaWNpbmZvIE1pcy5Ici5SZWFkLk1lLlBlcnNvbmFsaW5mbyIsInNpZCI6IjAwOThlYzg5LTE2NGQtZDk3Mi05MDkyLTM3YWRhOGU2NmY4ZSIsInN1YiI6IjYtUUJiek4wTVUtQk43LURkWlRPb0wtUWE0ZF9FQ3kwdnp0NmMzM0JTWVkiLCJ0aWQiOiJjZjgxZjFkZi1kZTU5LTRjMjktOTFkYS1hMmRmZDA0YWE3NTEiLCJ1bmlxdWVfbmFtZSI6ImtpdGlzYWsueUBjbXUuYWMudGgiLCJ1cG4iOiJraXRpc2FrLnlAY211LmFjLnRoIiwidXRpIjoiM1dPMEMxOUpRa3kwc2t1Q190Z1hBQSIsInZlciI6IjEuMCIsInhtc19mdGQiOiJZRThYaEllSS1xWmFBbVpNaUgyLXRPRnRFbHg4MlpqN3NEWmc2RndITzZFQmEyOXlaV0ZqWlc1MGNtRnNMV1J6YlhNIn0.A7Hh8xBijh6qcLTl_m7C4VN--Y3m1VOoQoVlnK3BjTWaXeORwH2Q7U2wix-wBcNoF19V7mgCU0vDWNrazfRpGjoVvcegtKQqx4Kfds7Dm_3Sb2W5oWp6bcedtsXn9jRhH6po-9EEGoW9Db-BwzBhgkbNCDG7qvYsk0Tt1KWEfxx9prb-FDkhpRlDzoQVHj97nC91UaR_IxKTHgagCaj1UdA4gZCT-qRUR6fMB_O3HM4s1SImWe7vnryUfvvNx_XNguY99C5NWgs9pn8g3J4TFSoahB842WcGMwKQyDnmvvUd9EQvY0PfChDzQpHsRy51wAigEtaHP3zjqVduaLhmtg'
const notification = {
  namespaced: true,

  state: {
    visible: false,
    text: '',
    color: ''
  },

  mutations: {
    ACTIVE_NOTIFICATION(state, payload) {
      let time = payload.time ? payload.time : 6000
      state.visible = true
      state.text = payload.text
      switch (payload.type) {
        case 'error':
          state.color = 'error'
          break
        case 'success':
          state.color = 'success'
          break
        default:
          state.color = 'error'
          break
      }
      setTimeout(() => {
        state.visible = false
        state.text = ''
        state.color = ''
      }, time)
    },

    RESET_NOTIFICATION(state) {
      state.visible = false
      state.text = ''
      state.time = 0
      state.color = ''
    }
  },
  actions: {
    getSelfLineNotification() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosLineNotiClient.get(
            '/LineNotificationSetting/0',
            {
              headers: {
                // Authorization: 'Bearer ' + localStorage.getItem('accesstoken')

                // Dev test
                Authorization: 'Bearer ' + TokenTest
              }
            }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    saveSelfLineNotification(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosLineNotiClient.put(
            `/LineNotificationSetting`,
            payload,
            {
              headers: {
                //Authorization: 'Bearer ' + localStorage.getItem('accesstoken')

                // Dev test
                Authorization: 'Bearer ' + TokenTest
              }
            }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    clearSelfLineNotification() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosLineNotiClient.put(
            `/LineNotificationSetting/reset`,
            null,
            {
              headers: {
                //Authorization: 'Bearer ' + localStorage.getItem('accesstoken')

                // Dev test
                Authorization: 'Bearer ' + TokenTest
              }
            }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  },
  getters: {}
}

export default notification
